import React from "react";
import { User } from "../../api/models/user-model";
import { useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import IconifyIcon from "../IconifyIcon";

interface UserCardProps {
  user: User;
  style: React.CSSProperties;
  onPress: () => void;
  role: "user" | "admin";
}

const UserCard = ({ user, style, onPress, role }: UserCardProps) => {
  const labels = useAppSelector(selectLabels);

  return (
    <div className="card border-box gap-4" style={style} onClick={onPress}>
      <div className="w-100 border-box p-4">
        <div className="w-100 border-box align-items-center justify-content-between">
          <div className="w-100 flex align-items-center">
            <p className="font-16 font-w-700 subtitle-color">{user?.name}</p>
          </div>
          <div className="w-100 align-items-center mt-4">
            {role === "admin" && (
              <p className="font-14 subtitle-color mb-4 font-w-500">
                {user?.unit?.name}
              </p>
            )}
            <p className="font-14 subtitle-color">{user?.email}</p>
            <p className="font-14 subtitle-color mt-2">{user?.phone}</p>
          </div>
          <div className="w-100 flex align-items-center justify-content-end mt-4 gap-2">
            <p
              className="font-14 font-w-500 subtitle-color"
              style={{
                color: user?.confirmed
                  ? user?.blocked
                    ? "#c2170e"
                    : "#15ab0f"
                  : "",
              }}
            >
              {user?.confirmed
                ? user?.blocked
                  ? labels.blocked
                  : labels.active
                : labels.pending}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
